import type { IsoView } from './IsoView.js';

/**
 * ISO data
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type IsoData = ArrayBuffer | DataView | IsoView | Uint8Array;
